




















import { Component, Vue, Prop } from 'vue-property-decorator'
import ThumbnailImage from './Components/thumbnailImage.vue'
import CoverImage from './Components/coverImage.vue'
import LogoImage from './Components/logoImage.vue'
import IconImage from './Components/iconImage.vue'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'
@Component({
  name: 'GalleryImage',
  components: {
    'thumbnail-image': ThumbnailImage,
    'cover-image': CoverImage,
    // 'logo-image': LogoImage,
    // 'icon-image': IconImage,
  },
})
export default class extends Vue {}
